import { MutationHookOptions, useMutation } from "@apollo/react-hooks";

import { Insurance } from "@hubcapp/types";
import updateInsuranceHistory from "../graph-ql/updateInsuranceHistory.graphql";

const useMutationUpdateInsuranceHistory = (opts?: MutationHookOptions) =>
  useMutation<{ updateInsuranceHistory: Insurance }>(
    updateInsuranceHistory,
    opts,
  );

export default useMutationUpdateInsuranceHistory;
